import PhotoSizeSelectActualIcon from "@mui/icons-material/PhotoSizeSelectActual";
import { Button } from "@mui/material";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

const GoToPhotosButton = ({ projectLineId }) => {
    const history = useHistory();
    const handleClick = useCallback(() => {
        if (projectLineId) history.push(`/photos/${projectLineId}`);
    }, [projectLineId, history]);

    return (
        <Button variant="outlined" fullWidth startIcon={<PhotoSizeSelectActualIcon />} color="primary" onClick={handleClick}>
            Photos
        </Button>
    );
};

export default GoToPhotosButton;
